import {ProfileStatus} from "../../domain/ProfileStatus";
import {V2ProfileStatusApiResponse} from "./mapper.types";

/**
 * Maps v2 `profile/status` responses to the ProfileStatus entity.
 * Tolerant Reader: any missing boolean defaults to `false`.
 *
 * Pure TypeScript - no React imports.
 */
export const ProfileStatusMapperV2 = {
  toDomain(response: V2ProfileStatusApiResponse): ProfileStatus {
    return ProfileStatus.create({
      profilePictureUploaded: response.profilePicture === true,
      bankAccountConnected: response.bankAccount === true,
      calendarConnected: response.calendarConnected === true,
      hasOffering: response.hasOffering === true,
      kycVerified: response.kycVerified === true,
    });
  },
};
